import React, { Fragment } from "react";
import { defineMessages } from "react-intl";
import validPhone from "assets/scripts/utils/validPhone";
import { ERRORS, REQUIRED } from "assets/scripts/constants/FormMessages";
import isEmpty from "assets/scripts/utils/isEmpty";
import tryParseNumber from "assets/scripts/utils/tryParseNumber";
import { getPreferredPhoneError } from "assets/scripts/domain/profile/utils";
import PhoneFormGroup from "assets/scripts/components/common/form/PhoneFormGroup/PhoneFormGroup";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import PhoneTypeFormGroup from "assets/scripts/components/common/form/PhoneTypeFormGroup/PhoneTypeFormGroup";
const messages = defineMessages({
    phoneHomeLabel: {
        id: "forms.profileEdit.phoneHome.label",
        defaultMessage: "Home Phone"
    },
    phoneHomeHelp: {
        id: "forms.profileEdit.phoneHome.help",
        defaultMessage: "Format: 123-456-7890"
    },
    phoneCellLabel: {
        id: "forms.profileEdit.phoneCell.label",
        defaultMessage: "Cell Phone"
    },
    phoneCellHelp: {
        id: "forms.profileEdit.phoneCell.help",
        defaultMessage: "Format: 123-456-7890"
    },
    phoneWorkLabel: {
        id: "forms.profileEdit.phoneWork.label",
        defaultMessage: "Work Phone"
    },
    phoneWorkHelp: {
        id: "forms.profileEdit.phoneWork.help",
        defaultMessage: "Format: 123-456-7890"
    },
    phoneWorkExtLabel: {
        id: "forms.profileEdit.phoneWorkExt.label",
        defaultMessage: "Ext."
    },
    phoneWorkExtHelp: {
        id: "forms.profileEdit.phoneWorkExt.help",
        defaultMessage: "# only"
    },
    preferredPhoneLabel: {
        id: "forms.profileEdit.preferredPhone.label",
        defaultMessage: "Preferred Phone"
    },
    preferredPhoneNullOption: {
        id: "forms.profileEdit.preferredPhone.nullOption",
        defaultMessage: "Preferred Phone"
    }
});
export function getErrors(value) {
    return {
        phoneHome: !validPhone(value.phoneHome) ? ERRORS.PHONE :
            !value.phoneHome && !value.phoneCell && !value.phoneWork ? "Please enter at least one phone number" : null,
        phoneCell: !validPhone(value.phoneCell) ? ERRORS.PHONE :
            !value.phoneHome && !value.phoneCell && !value.phoneWork ? "Please enter at least one phone number" : null,
        phoneWork: !validPhone(value.phoneWork) ? ERRORS.PHONE :
            !value.phoneHome && !value.phoneCell && !value.phoneWork ? "Please enter at least one phone number" : null,
        phoneWorkExt: !isEmpty(value.phoneWorkExt) && tryParseNumber(value.phoneWorkExt) == null ? REQUIRED : null,
        preferredPhone: !value.phoneHome && !value.phoneCell && !value.phoneWork ? null : getPreferredPhoneError(value.preferredPhone, value)
    };
}
export default function ProfilePhoneInputs({ value, errors, backendErrors, onChange }) {
    const handleChange = (update) => onChange({
        ...value,
        ...update
    });
    return (<Fragment>
			<PhoneFormGroup name="phoneHome" className="form-group-phoneHome" label={messages.phoneHomeLabel} help={messages.phoneHomeHelp} value={value.phoneHome} onChange={phoneHome => handleChange({ phoneHome })} error={errors.phoneHome} backendError={backendErrors.homePhone} inputProps={{
        autoComplete: "tel"
    }}/>

			<PhoneFormGroup name="phoneCell" className="form-group-phoneCell" label={messages.phoneCellLabel} help={messages.phoneCellHelp} value={value.phoneCell} onChange={phoneCell => handleChange({ phoneCell })} error={errors.phoneCell} backendError={backendErrors.cellPhone}/>

			<PhoneFormGroup name="phoneWork" className="form-group-phoneWork" label={messages.phoneWorkLabel} help={messages.phoneWorkHelp} value={value.phoneWork} onChange={phoneWork => handleChange({ phoneWork })} error={errors.phoneWork} backendError={backendErrors.workPhone}/>

			<TextFormGroup type="number" name="phoneWorkExt" className="form-group-phoneWorkExt" label={messages.phoneWorkExtLabel} help={messages.phoneWorkExtHelp} value={value.phoneWorkExt || ""} onChange={phoneWorkExt => handleChange({ phoneWorkExt })} error={errors.phoneWorkExt} backendError={backendErrors.workPhoneExtension} inputProps={{
        autoComplete: "tel-extension"
    }}/>

			<PhoneTypeFormGroup name="preferredPhone" label={messages.preferredPhoneLabel} value={value.preferredPhone} onChange={preferredPhone => handleChange({ preferredPhone })} error={errors.preferredPhone} backendError={backendErrors.preferredPhone} required nullOption={messages.preferredPhoneNullOption}/>
		</Fragment>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfilePhoneInputs/ProfilePhoneInputs.tsx